<template>
  <mp-drawer class-name="modal-select" size="xl" :is-open="isOpen" :on-close="close" close-on-overlay-click>
    <mp-drawer-content>
      <mp-drawer-header>{{ title }}</mp-drawer-header>
      <mp-drawer-close-button />
      <mp-drawer-body>
        <mp-box v-if="subtitle" font-weight="semibold" mb="4" mx="1">{{ subtitle }}</mp-box>
        <mp-flex :h="`calc(100vh - 44px - 78px - 36px${subtitle ? ' - 28px' : ''})`" overflow="hidden" mb="-12px">
          <mp-box :class="['content', { open: isFilter }]" flex="1">
            <mp-flex justify-content="space-between" align-items="center" mb="5">
              <button @click="isFilter = !isFilter">
                <mp-flex gap="2" align-items="center">
                  <mp-icon name="arrows-left" color="black" size="sm" variant="fill" />
                  <mp-text font-weight="semibold">
                    Filter
                  </mp-text>
                </mp-flex>
              </button>
              <button @click="clearFilter">
                <mp-text color="gray.400">Reset filter</mp-text>
              </button>
            </mp-flex>
            <mp-flex flex-direction="column" gap="4" h="calc( 60vh - 60px )" overflow-y="auto">
              <mp-box>
                <mp-text font-weight="semibold"> Branch</mp-text>
                <mp-select v-model="branch" placeholder="All branch">
                  <option v-for="{ id, name } in $store.getters.branchData" :key="id" :value="id">{{ name }}</option>
                </mp-select>
              </mp-box>
              <mp-box>
                <mp-text font-weight="semibold"> Organization</mp-text>
                <mp-select v-model="organization" placeholder="All organization">
                  <option v-for="{ id, name } in $store.getters.organizationData" :key="id" :value="id">{{ name }}</option>
                </mp-select>
              </mp-box>
              <mp-box>
                <mp-text font-weight="semibold"> Job level</mp-text>
                <mp-select v-model="jobLevel" placeholder="All job level">
                  <option v-for="{ id, name } in $store.getters.jobLevelData" :key="id" :value="id">{{ name }}</option>
                </mp-select>
              </mp-box>
              <mp-box>
                <mp-text font-weight="semibold"> Job position</mp-text>
                <mp-select v-model="jobPosition" placeholder="All job position">
                  <option v-for="{ id, name } in $store.getters.jobPositionData" :key="id" :value="id">{{ name }}</option>
                </mp-select>
              </mp-box>
              <mp-box>
                <mp-text font-weight="semibold"> Employee status</mp-text>
                <mp-select v-model="employeeStatus" placeholder="All employee status">
                  <option v-for="{ id, name } in $store.getters.employeeStatusData" :key="id" :value="id">{{ name }}</option>
                </mp-select>
              </mp-box>
              <mp-box>
                <mp-button variant="outline" @click="onSearch">
                  Apply filter
                </mp-button>
              </mp-box>
            </mp-flex>
          </mp-box>
          <mp-divider v-if="isFilter" mx="4" orientation="vertical" mt="-16px !important" mb="-16px !important" />
          <mp-box ref="scrollableWrapper" flex="1">
            <mp-flex align-items="center" gap="2" mb="4">
              <mp-input-group>
                <mp-input-left-addon :with-background="false">
                  <mp-icon name="search" size="sm" />
                </mp-input-left-addon>
                <mp-input v-model="search" :placeholder="searchPlaceholder" is-clearable @input="onSearchDebounce" />
              </mp-input-group>
              <mp-button left-icon="filter" border-color="gray.100" variant="outline" @click="isFilter = !isFilter">
                Filter
              </mp-button>
            </mp-flex>

            <mp-flex justify-content="space-between" align-items="center" mb="4">
              <mp-text font-weight="semibold" font-size="lg">Employees ({{ formatCurrency(total) }})</mp-text>
            </mp-flex>

            <mp-box ref="scrollable" h="calc(100% - 88px)" overflow-y="auto" position="relative" @scroll.native="onScroll">
              <mp-text
                v-if="filteredSuggested.length"
                font-weight="semibold"
                bg-color="background"
                py="6px"
                pl="1"
                position="sticky"
                top="0"
                z-index="1"
                border-bottom="1px"
                border-color="gray.100"
              >
                Employee suggestion
              </mp-text>
              <member-item
                v-for="item in filteredSuggested"
                :id="item.id_employee"
                :key="item.id_employee"
                :name="`${item.first_name} ${item.last_name}`"
                :avatar="item.url_avatar"
                :title="item.job || ''"
                @click.native="onAdd(item)"
              />
              <mp-text
                v-if="filteredEmployee.length"
                font-weight="semibold"
                bg-color="background"
                py="6px"
                pl="1"
                border-bottom="1px"
                border-color="gray.100"
                position="sticky"
                z-index="2"
                top="0"
              >
                All employee
              </mp-text>
              <member-item
                v-for="item in filteredEmployee"
                :id="item.id_employee"
                :key="item.id_employee"
                :name="`${item.first_name} ${item.last_name}`"
                :avatar="item.url_avatar"
                :title="item.job || ''"
                @click.native="onAdd(item)"
              />
              <mp-flex v-if="isLoading" my="4" align-items="center" flex-direction="column">
                <mp-spinner display="block" label="Loading..." my="6" />
              </mp-flex>
              <mp-text
                v-else-if="!filteredData.length && (search || organization || branch || jobLevel || jobPosition || employeeStatus)"
                text-align="center"
                my="4"
                color="gray.600"
                >No data found
              </mp-text>
              <mp-text v-else-if="!hasNext && filteredData.length" text-align="center" my="4" color="gray.600"
                >You’ve reached the last of employee list
              </mp-text>
            </mp-box>
          </mp-box>
          <mp-divider v-if="!isFilter" mx="4" orientation="vertical" mt="-16px !important" mb="-16px !important" />
          <mp-box flex="1" :class="['content', { open: !isFilter }]">
            <mp-input-group v-if="selected.length || searchSelected" mb="4">
              <mp-input-left-addon :with-background="false">
                <mp-icon name="search" size="sm" />
              </mp-input-left-addon>
              <mp-input v-model="searchSelected" :placeholder="searchPlaceholder" is-clearable @clear="searchSelected = ''" />
            </mp-input-group>

            <mp-flex justify-content="space-between" align-items="center" mb="4">
              <mp-text font-weight="semibold" font-size="lg">Selected employees ({{ formatCurrency(selected.length) }}) </mp-text>
              <mp-button :is-disabled="!selected.length" variant="link" @click="clearSelection">
                Clear selection
              </mp-button>
            </mp-flex>

            <mp-box h="calc(100% - 88px)" overflow-y="auto">
              <member-item
                v-for="(item, index) in filteredSelected"
                :id="item.id_employee"
                :key="item.id_employee"
                :name="`${item.first_name} ${item.last_name}`"
                :avatar="item.url_avatar"
                :title="item.job ? item.job.job || item.job : ''"
                icon="minus-circular"
                @click.native="onRemove(item, index)"
              />
              <mp-flex v-if="!selected.length && !searchSelected" flex-direction="column" text-align="center" gap="2" pt="8">
                <mp-icon name="team" w="54px" h="54px" variant="duotone" mx="auto" />
                <mp-text font-size="lg" font-weight="semibold">
                  No employee selected
                </mp-text>
                <mp-text color="gray.600">
                  You must select at least one from employee list from the left.
                </mp-text>
              </mp-flex>
              <mp-text v-else-if="!filteredSelected.length && searchSelected" text-align="center" my="4" color="gray.600">No data found </mp-text>
            </mp-box>
          </mp-box>
        </mp-flex>
      </mp-drawer-body>
      <mp-drawer-footer border-top="1px" border-color="gray.100" display="flex" pt="5" px="4" pb="5" justify-content="flex-end">
        <mp-button variant="ghost" margin-right="3" @click="close">Cancel</mp-button>
        <mp-button :is-loading="isLoadingSubmit" @click="submit">Submit</mp-button>
      </mp-drawer-footer>
    </mp-drawer-content>
    <mp-modal-overlay />
  </mp-drawer>
</template>

<script>
import { debounce } from 'lodash-es';
import { buildParams } from '@/helpers/url';
import { alertMixin } from '@/mixins/general';
import MemberItem from '@/components/MemberItem';
import { formatCurrency } from '@/helpers/number';

export default {
  name: 'ModalAddMember',
  components: {
    MemberItem,
  },
  mixins: [alertMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Add member',
    },
    subtitle: {
      type: String,
      default: '',
    },
    searchPlaceholder: {
      type: String,
      default: 'Search employee name',
    },
    selectedMember: {
      type: Array,
      default: () => [],
    },
    url: {
      type: String,
      default: '',
    },
    maxSelect: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isFilter: false,
      searchSelected: '',
      search: '',
      selected: [],
      data: [],
      currentPage: 1,
      hasNext: false,
      isLoading: false,
      isLoadingSubmit: false,
      total: 0,
      organization: '',
      branch: '',
      jobLevel: '',
      jobPosition: '',
      employeeStatus: '',
      limit: 50,
    };
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.data = [];
        this.selected = [...this.selectedMember];
        this.limit = this.selected.length > 50 ? this.selected.length + 50 : 50;
        this.$store.dispatch('getUserFilters', { showAll: false });
        this.clearFilter();
      }
    },
  },
  computed: {
    filteredData() {
      return this.data.filter(i => !this.selected.map(e => e.id).includes(i.id));
    },
    filteredEmployee() {
      return this.filteredData.filter(i => !i.isSelected && !i.isSuggested) || [];
    },
    filteredSuggested() {
      return this.filteredData.filter(i => !i.isSelected && i.isSuggested) || [];
    },
    filteredSelected() {
      const query = this.searchSelected.toLowerCase() || '';
      return (
        this.selected.filter(e => {
          const name = `${e.first_name} ${e.last_name}`.toLowerCase();
          return name.includes(query);
        }) || []
      );
    },
  },
  methods: {
    formatCurrency,
    validMaxSelect(type) {
      const max = type === 'submit' ? this.maxSelect + 1 : this.maxSelect;
      if (this.maxSelect && this.selected.length >= max) {
        this.alertToast(`Maximum limit reached. You can select up to ${this.maxSelect} contributors.`, 'danger');
        return false;
      }
      return true;
    },
    onAdd(member) {
      if (!this.validMaxSelect()) return;
      if (this.$refs.scrollable.$el.scrollHeight < this.$refs.scrollableWrapper.$el.offsetHeight && this.hasNext && !this.isLoading) {
        this.currentPage += 1;
        this.fetch();
      }
      this.isFilter = false;
      member.isSelected = true;
      this.selected.push(member);
    },
    onRemove(member, index) {
      const idx = this.data.findIndex(e => e.id_employee === member.id_employee);
      if (idx !== -1) this.data[idx].isSelected = false;
      this.selected.splice(index, 1);
    },
    close() {
      this.$emit('update:isOpen', false);
    },
    clearFilter() {
      this.organization = '';
      this.branch = '';
      this.jobLevel = '';
      this.jobPosition = '';
      this.employeeStatus = '';
      this.onSearch();
    },
    clearSelection() {
      this.data.forEach(e => {
        e.isSelected = false;
      });
      this.selected = [];
    },
    async fetch() {
      this.isLoading = true;

      const params = {
        organization: this.organization,
        branch: this.branch,
        job_level: this.jobLevel,
        job_position: this.jobPosition,
        search_data: this.search || '',
        search: this.search || '',
        employee_status: this.employeeStatus,
        page: this.currentPage,
        limit_per_page: this.limit,
      };

      try {
        const { data } = await this.$axios.get(`${this.url}?${buildParams(params)}`);
        const content = data.contents?.users || data.contents;

        const arr = content.data.map(user => ({
          ...user,
          url_avatar: user?.url_avatar || user?.avatar || '', // calibration(?) || goal form & upload || default
          job: user?.job?.job || user?.job_name || '', // php || golang || default
          organization: user?.organization?.organization || '', // php || default
          full_name: `${user?.first_name} ${user?.last_name}`,
          isSelected: false,
          isSuggested: user?.is_suggested || false, // php || default
        }));

        this.data = this.currentPage === 1 ? arr : this.data.concat(arr);
        this.hasNext = !!content.next_page_url;
        this.total = content.total;
      } finally {
        this.isLoading = false;
      }
    },
    submit() {
      if (!this.validMaxSelect('submit')) return;
      this.$emit('save', this.selected);
      this.close();
    },
    onSearchDebounce: debounce(function() {
      this.onSearch();
    }, 400),
    onSearch() {
      this.data = [];
      this.currentPage = 1;
      this.fetch();
    },
    onScroll: debounce(function(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      const pixelTolerance = 30;
      if (!this.isLoading && this.hasNext && scrollTop + clientHeight + pixelTolerance >= scrollHeight) {
        this.currentPage += 1;
        this.fetch();
      }
    }, 400),
  },
};
</script>
